import type { FeatureMetadata } from '../../types';
import { getFromStorage } from '../storage-api-utils';
import { isFeatureMetadata } from './isFeatureMetadata';

export const readMetadata = (metadataKey: string, storage: Storage): FeatureMetadata => {
    const raw = getFromStorage(metadataKey, storage);

    if (raw && isFeatureMetadata(raw)) {
        return raw;
    }

    return { registry: {} };
};
